import { Box, Divider, Stack, Typography } from "@mui/material";
import { CartItem, EventDetails } from "../types";
import { CartCard, PremiumButton } from "../styles";
import { rupiah } from "../../../../utils/currency";

interface DesktopCartProps {
  filteredItems: CartItem[];
  totalTickets: number;
  totalPrice: number;
  totalFinalPrice: number;
  eventDetails: EventDetails;
  onProceed: () => void;
}

export function DesktopCart({
  filteredItems,
  totalTickets,
  totalPrice,
  totalFinalPrice,
  eventDetails,
  onProceed
}: DesktopCartProps) {
  return (
    <CartCard>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
        Order Summary
      </Typography>
      
      <Divider sx={{ mb: 2 }} />
      
      {filteredItems.length > 0 ? (
        <>
          <Stack spacing={2} sx={{ mb: 3 }}>
            {filteredItems.map((item: any) => (
              <Box key={item.category_id} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                  <Typography variant="body2" fontWeight="500">
                    {item.category_name}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {rupiah(item.price)} × {item.quantity}
                  </Typography>
                </Box>
                <Typography variant="body2" fontWeight="bold">
                  {rupiah(item.price * item.quantity)}
                </Typography>
              </Box>
            ))}
          </Stack>

          <Divider sx={{ mb: 2 }} />

          <Stack spacing={1} sx={{ mb: 2 }}>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2">Subtotal</Typography>
              <Typography variant="body2">{rupiah(totalPrice)}</Typography>
            </Box>
            
            {!eventDetails.include_tax && (
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2">Tax ({eventDetails.ppn}%)</Typography>
                <Typography variant="body2">
                  {rupiah((totalPrice * eventDetails.ppn) / 100)}
                </Typography>
              </Box>
            )}
            
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2">Platform Fee</Typography>
              <Typography variant="body2">
                {rupiah(
                  eventDetails.is_persen
                    ? (totalPrice * eventDetails.fee) / 100
                    : eventDetails.fee
                )}
              </Typography>
            </Box>
          </Stack>
          
          <Divider sx={{ mb: 2 }} />
          
          <Box display="flex" justifyContent="space-between" sx={{ mb: 3 }}>
            <Typography variant="h6" fontWeight="bold">Total</Typography>
            <Typography variant="h6" fontWeight="bold" color="primary">
              {rupiah(totalFinalPrice)}
            </Typography>
          </Box>

          <PremiumButton
            variant="contained"
            fullWidth
            onClick={onProceed}
            sx={{ py: 1.5 }}
          >
            Checkout ({totalTickets} tickets)
          </PremiumButton>
        </>
      ) : (
        <Box textAlign="center" py={4}>
          <Typography variant="body1" color="textSecondary" gutterBottom>
            Your cart is empty
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Add tickets to get started
          </Typography>
        </Box>
      )}
    </CartCard>
  );
}
